//utils
import {translateVideosName} from '../../../utils/helpers';
//components
import {
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  Avatar,
} from '@material-ui/core';
//styles
import classes from './videoStepper.module.css';


const VideoStepper = (props: any) => {

  const CustomStepIcon = (type: any, key: string) => {
    return (
      <div>
        <Avatar
          alt="Remy Sharp"
          src={`./video/icons/${key}-${type}.svg`}
          className={` ${classes.icon} ${
            type == 'SEEN'
              ? classes.seen
              : type == 'SEMI_SEEN'
              ? classes.semiSeen
              : classes.notSeen
          }`}
        />
      </div>
    );
  };
  //JSX
  return (
    <Stepper
      activeStep={1}
      alternativeLabel
      connector={<StepConnector />}
      className={classes.container}
    >
      {Object.entries(props.steps).reverse().map((stepObj: any, index: number) => {
        return (
          <Step key={stepObj[0]} active={true}>
            <StepLabel
              onClick={() => {
                props.selectCategoryHandler(stepObj);
              }}
              StepIconComponent={() =>
                CustomStepIcon(stepObj[1].categorySeenStatus, stepObj[0])
              }
            >
              {translateVideosName(stepObj[0])}
            </StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
};

export default VideoStepper;
